import * as ReactTooltip from "@radix-ui/react-tooltip"
import * as React from "react"

import { cx } from "./cva.ts"

const TooltipProvider = (props: ReactTooltip.TooltipProviderProps) => (
  <ReactTooltip.Provider delayDuration={300} {...props} />
)
const Tooltip = ReactTooltip.Root

const TooltipTrigger = ReactTooltip.Trigger

const TooltipContent = React.forwardRef<
  React.ComponentRef<typeof ReactTooltip.Content>,
  React.ComponentPropsWithoutRef<typeof ReactTooltip.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <ReactTooltip.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cx(
      "z-50 overflow-hidden rounded-sm px-1.5 py-1",
      "bg-gray-12 dark:bg-gray-3",
      "text-xs text-gray-1 dark:text-gray-12",
      "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className,
    )}
    {...props}
  />
))

export { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger }
